// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"685":"0087bffe","687":"221cfbde","787":"2f467f73","804":"16bcd34b"}[chunkId] + ".chunk.js";
};